<template>
  <span class="gx-pss">
    <span class="gx-pss__label">每页</span>
    <span class="gx-pss__select" @click="open = !open">
      <span class="gx-pss__value">{{ value }}</span>
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" :style="{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .18s' }"><path d="M1 2.5l3 3 3-3" stroke="#4A4A6A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
    </span>
    <span class="gx-pss__label">条</span>
    <div v-if="open" class="gx-pss__panel">
      <button v-for="opt in options" :key="opt" class="gx-pss__opt" :class="{ 'gx-pss__opt--on': opt === value }" @click="select(opt)">{{ opt }}</button>
    </div>
  </span>
</template>

<script>
export default {
  name: 'PageSizeSelect',
  props: {
    value: { type: Number, default: 20 },
    options: { type: Array, default: () => [10, 20, 50, 100, 200] }
  },
  data() {
    return { open: false }
  },
  methods: {
    select(opt) {
      this.$emit('change', opt)
      this.open = false
    }
  }
}
</script>

<style scoped>
.gx-pss {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-pss__select {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 26px;
  padding: 0 8px;
  border-radius: 5px;
  border: 1px solid rgba(212, 169, 70, .25);
  background: #FFFFFF;
  cursor: pointer;
  transition: border .15s;
  min-width: 48px;
  justify-content: space-between;
  box-sizing: border-box;
}
.gx-pss__select:hover {
  border-color: rgba(212, 169, 70, .55);
}
.gx-pss__value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-pss__panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 24px;
  min-width: 72px;
  border-radius: 8px;
  overflow: hidden;
  z-index: 400;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .22);
  box-shadow: 0 10px 28px rgba(0, 0, 0, .35);
}
.gx-pss__opt {
  width: 100%;
  padding: 7px 12px;
  text-align: left;
  border: none;
  cursor: pointer;
  background: #fff;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #1A1A2E;
  transition: background .12s;
}
.gx-pss__opt:hover {
  background: #F5F0E8;
}
.gx-pss__opt--on {
  background: rgba(212, 169, 70, .1);
  color: #D4A946;
  font-weight: 600;
}
</style>
